import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import Select from "react-select";

const MIDHList = () => {
    const navigate = useNavigate();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
    const stateCodeModel = sessionStorage.getItem("stateNameModel");
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [finYear, setFinYear] = useState(() => {
            return getCurrentFinancialYear();
        });
        const finYearStatic = getCurrentFinancialYear();
        // Function to fetch and set initial district data
    const fetchInitialDistrict = async (stateCode, districtCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            var raw = JSON.stringify({
                stateCode: stateCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataDistrict = JSON.parse(result).dataContent;
            
            let myArrayDistrict = localFormDataDistrict.map((item) => ({
                label: item.districtName,
                value: item.districtCode,
                stateid: item.stateCode
            }));

            setOptionDistrict(myArrayDistrict);

            // Find and select the matching district
            const matchingDistrict = myArrayDistrict.find(d => d.value.toString() === districtCode.toString());
            if (matchingDistrict) {
                setDistrictValue([matchingDistrict.value]);
                setselectedDataSetDistrict(`${matchingDistrict.stateid}|${matchingDistrict.value}`);
                // Trigger subdistrict fetch
                handleChangeDistrict([matchingDistrict]);
            }
        } catch (error) {
            console.error("Error fetching initial district data:", error);
        }
    };

const handleFinYearChange = (e) => {
        const value = String(e.target.value || "");
        sessionStorage.setItem("finYear", value);
        setFinYear(value);
      //  assignTargetData();
        // console.log('getCurrentFinancialYear: ',getCurrentFinancialYear());
    };

    // Add state variable for sub-district disabled state
    const [isSubDistrictDisabled, setIsSubDistrictDisabled] = useState(false);
function getCurrentFinancialYear() {
        const today = new Date();
        let year = today.getFullYear();

        // If month is Jan, Feb, or Mar (0 = Jan), financial year starts from previous year
        if (today.getMonth() < 3) {
            return `${year - 1}-${year}`;
        } else {
            return `${year}-${year + 1}`;
        }
    }
    useEffect(() => {
        getStates();
    }, []);

    // Function to fetch sub-districts for auto-selected district
    const fetchSubDistricts = async (stateCode, districtCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/subdistrict`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataSubDistrict = JSON.parse(result).dataContent;

            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });

            setOptionSubDistrict(myArraySubDistrict);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching sub-districts:", error);
        }
    };

    // Function to fetch villages for auto-selected sub-district
    const fetchVillages = async (stateCode, districtCode, subDistrictCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString(),
                subDistrictCode: subDistrictCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataVillage = JSON.parse(result).dataContent;

            let myArrayVillage = [];
            localFormDataVillage.map((item, key) => {
                myArrayVillage.push({ 
                    label: item.villageName, 
                    value: item.villageCode, 
                    subDistrictCode: item.subDistrictCode 
                });
            });

            setOptionVillage(myArrayVillage);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching villages:", error);
        }
    };

    // New useEffect to handle user-level restrictions after states are loaded
    useEffect(() => {
        if (optionState.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const stateCode = sessionStorage.getItem("stateNameModel");
            const districtCode = sessionStorage.getItem("districtNameModel");
            const subDistrictCode = sessionStorage.getItem("subDistrictNameModel"); 
          
            // First, select the values based on user permissions
            if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // State level user - auto-select state
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // District level user - auto-select state
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // Sub-district level user - auto-select state
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else {
                // Regular user or admin - no auto-selection
                setStateValue([]);
            }
        }
    }, [optionState]); // Trigger when state options are loaded

    // Separate useEffect to freeze dropdowns after values are set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = sessionStorage.getItem("districtNameModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
        // Set disabled states based on user type and available values
        if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
            // State admin - freeze state dropdown only
            setIsStateDisabled(true);
            setIsDistrictDisabled(false);
            setIsSubDistrictDisabled(false);
        } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
            // District admin - freeze state dropdown, district will be frozen after it's selected
            setIsStateDisabled(true);
            // District will be disabled in the district useEffect
        } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
            // Sub-district admin - freeze state dropdown, others will be frozen after they're selected
            setIsStateDisabled(true);
            // For sub-district admin, also set district disabled state if district code is available
            if (districtCode && districtCode !== "null" && districtCode !== "0") {
                setIsDistrictDisabled(true);
            }
            // District and sub-district will be disabled in their respective useEffects
        } else {
            // Regular user - enable all
            setIsStateDisabled(false);
            setIsDistrictDisabled(false);
            setIsSubDistrictDisabled(false);
        }
    }, [stateValue]); // Trigger when stateValue changes
    //Fina Year 
    useEffect(() => {
            sessionStorage.setItem("finYear", finYear);
        }, [finYear]);
    // New useEffect to handle district auto-selection after districts are loaded
    useEffect(() => {
        if (optionDistrict.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const districtCode = sessionStorage.getItem("districtCodeModel") || sessionStorage.getItem("districtNameModel");
            
            // First select the district value
            if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0") {
                // Try to find the matching district option and use its exact value format
                const matchingDistrictOption = optionDistrict.find(option => option.value == districtCode || option.value === Number(districtCode) || option.value === String(districtCode));
                if (matchingDistrictOption) {
                    setDistrictValue([matchingDistrictOption.value]);
                    setselectedDataSetDistrict(`${matchingDistrictOption.stateid}|${matchingDistrictOption.value}`);
                    
                    // Trigger sub-district loading by calling the API directly
                    const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                    if (stateCode) {
                        fetchSubDistricts(stateCode, matchingDistrictOption.value);
                    }
                } else {
                    setDistrictValue([districtCode]);
                }
            }
        }
    }, [optionDistrict]); // Trigger when district options are loaded

    // Separate useEffect to freeze district dropdown after district value is set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const districtCode = sessionStorage.getItem("districtCodeModel") || sessionStorage.getItem("districtNameModel");
        
        // Freeze district dropdown for district and sub-district admins
        if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0" && districtValue.length > 0) {
            setIsDistrictDisabled(true);
        }
    }, [districtValue]); // Trigger when districtValue changes

    // New useEffect to handle sub-district auto-selection after sub-districts are loaded
    useEffect(() => {
        if (optionSubDistrict.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
            
            // First select the sub-district value
            if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0") {
                // Try to find matching option with different data types
                const matchingOption = optionSubDistrict.find(option => 
                    option.value == subDistrictCode || 
                    option.value === Number(subDistrictCode) || 
                    option.value === String(subDistrictCode)
                );
                
                if (matchingOption) {
                    setsubDistrictValue([matchingOption.value]);
                    setselectedDataSetSubDistrict(`${matchingOption.districtCode}|${matchingOption.value}`);
                    
                    // Trigger village loading for sub-district admin
                    const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                    const districtCode = districtValue[0] || sessionStorage.getItem("districtNameModel") || matchingOption.districtCode;
                    
                    if (stateCode && districtCode) {
                        fetchVillages(stateCode, districtCode, matchingOption.value);
                    }
                } else {
                    setsubDistrictValue([subDistrictCode]);
                }
            }
        }
    }, [optionSubDistrict, stateValue, districtValue]); // Trigger when sub-district options are loaded and state/district values are set

    // Separate useEffect to freeze sub-district dropdown after sub-district value is set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
        // Freeze sub-district dropdown for sub-district admins
        if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" && subdistrictValue.length > 0) {
            setIsSubDistrictDisabled(true);
        }
    }, [subdistrictValue]); // Trigger when subdistrictValue changes

    // Additional useEffect to ensure village loading for sub-district admin when all values are ready
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
        // If sub-district admin and all required values are available, ensure villages are loaded
        if (userType === "4" && 
            subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" &&
            stateValue.length > 0 && 
            districtValue.length > 0 && 
            subdistrictValue.length > 0 &&
            optionVillage.length === 0) { // Only if villages aren't already loaded
            
            fetchVillages(stateValue[0], districtValue[0], subdistrictValue[0]);
        }
    }, [stateValue, districtValue, subdistrictValue, optionVillage]); // Trigger when any of these change

    useEffect(() => {
        if (isFetchingState == false) {
            handleState();
            setIsFetchingState(true);
        }
    }, [stateValue]);

  function getStates() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };

    fetch(
        `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`,
        requestOptions
    )
        .then((response) => response.text())
        .then((result) => {
            const localFormDataState = JSON.parse(result).dataContent;
            const myArray = localFormDataState.map((item) => ({
                label: item.stateName,
                value: item.stateCode,
            }));

            setOptionState(myArray);
            setIsFetching(false);

            // Auto-select and lock state based on user's session
            const stateNameModel = sessionStorage.getItem("stateNameModel");
            if (stateNameModel && stateNameModel !== "0" && stateNameModel !== "null") {
                const selected = myArray.find(item => item.value.toString() === stateNameModel);
                if (selected) {
                    setStateValue([selected.value]); // Set just the value for the state
                    setIsStateDisabled(true);
                    // Trigger district fetch
                    setTimeout(() => {
                        handleState();
                    }, 100);
                }
            }
        })
        .catch((error) => {
            console.error("Error fetching states:", error);
            setIsFetching(false);
        });
}


    function handleState() {
        setOptionDistrict([]);
        setsubDistrictValue([]);
        setvillageValue([]);
        
        // Get state code from session if it exists, otherwise use selected state
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const stateNameModel = sessionStorage.getItem("stateNameModel");
        const districtCodeModel = sessionStorage.getItem("districtNameModel");
       // let stateCode = stateNameModel !== "0" && stateNameModel !== "null" ? stateNameModel : (stateValue.length > 0 ? stateValue[0] : null);
        
       let stateCode;

  if (userType === "1") {
    stateCode = stateValue.length > 0 ? stateValue[0] : null;
  } else {
    stateCode =
      stateNameModel !== "0" && stateNameModel !== "null"
        ? stateNameModel
        : (stateValue.length > 0 ? stateValue[0] : null);
  }
        if (!stateCode) {
            return false;
        }

        // Handle district based on whether it's locked
        if (isDistrictDisabled && districtCodeModel && districtCodeModel !== "0" && districtCodeModel !== "null") {
            // If district is locked, fetch and set the district data
            fetchInitialDistrict(stateCode, districtCodeModel);
        } else {
            setDistrictValue([]);
            setselectedDataSetDistrict('');
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
            stateCode: stateCode
        });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/district`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataDistrict = JSON.parse(result).dataContent;

                        let myArrayDistrict = [];
                        localFormDataDistrict.map((item, key) => {
                            myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                        })

                        setOptionDistrict(myArrayDistrict);
                        
                        // If district is locked, auto-select it from the fetched options
                        const districtCodeModel = sessionStorage.getItem("districtNameModel");
                        if (isDistrictDisabled && districtCodeModel && districtCodeModel !== "0" && districtCodeModel !== "null") {
                            const matchingDistrict = myArrayDistrict.find(d => d.value.toString() === districtCodeModel.toString());
                            if (matchingDistrict) {
                                setDistrictValue([matchingDistrict.value]);
                                setselectedDataSetDistrict(`${matchingDistrict.stateid}|${matchingDistrict.value}`);
                                // Trigger subdistrict fetch
                                handleChangeDistrict([matchingDistrict]);
                            }
                        }
                      
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));
            }
        



    let handleChangeDistrict = (districtValue) => {
        // Check if district selection is disabled for this user type
        if (isDistrictDisabled) {
            console.log("District change blocked - User has district restrictions");
            return;
        }
        
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setvillageValue([]);
        if (districtValue.length > 1) {
            alert('Please select one value');
            setDistrictValue([]);
            return false;
        }
        else {
            if (districtValue.length === 0) {
                setDistrictValue([]);
                setselectedDataSetDistrict('');
                return;
            }

            // Get state code from session or selected state
            const stateNameModel = sessionStorage.getItem("stateNameModel");
            const stateCode = stateNameModel !== "0" && stateNameModel !== "null" ? 
                            stateNameModel : stateValue[0];

            setDistrictValue(districtValue.map(option => option.value));
            setselectedDataSetDistrict(districtValue.map(item => `${stateCode}|${item.value}`).join(','));

            if (districtValue.length > 0) {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                const districtValueData = districtValue[0].value;


                var raw = JSON.stringify({
                    stateCode: stateCode.toString(),
                    districtCode: districtValueData.toString()
                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/subdistrict`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataSubDistrict = JSON.parse(result).dataContent;

                        let myArraySubDistrict = [];
                        localFormDataSubDistrict.map((item, key) => {
                            myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                        })

                        setOptionSubDistrict(myArraySubDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }
    };

    let handleChangeSubDistrict = (subdistrictValue) => {

        // Check if sub-district selection is disabled for this user type
        if (isSubDistrictDisabled) {
            console.log("Sub-district change blocked - User has sub-district restrictions");
            return;
        }
        
        setvillageValue([]);
        setOptionVillage([]);
        if (subdistrictValue.length > 1) {
            alert('Please select one value');
            setsubDistrictValue([]);
            return false;
        }
        else {
            setsubDistrictValue(subdistrictValue.map(option => option.value));
            setselectedDataSetSubDistrict(subdistrictValue.map(item => `${item.districtCode}|${item.value}`).join(','));

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item
            })

            let districtValueData = "";
            districtValue.map((item) => {
                districtValueData = districtValueData + item
            })

            let subdistrictValueData = "";
            subdistrictValue.map((item) => {
                subdistrictValueData = subdistrictValueData + item.value
            })


            if (subdistrictValue.length != 0) {

                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString(),
                    subDistrictCode: subdistrictValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/village`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataVillage = JSON.parse(result).dataContent;

                        let myArrayVillage = [];
                        localFormDataVillage.map((item, key) => {
                            myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                        })

                        setOptionVillage(myArrayVillage)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }


    };

    const fetchDataFilterWise = async () => {
        let result;
        let result1;
       // alert(sessionStorage.getItem("schemeCodeModel"))
        //alert(sessionStorage.getItem("schemeCodeModel"));
      if (sessionStorage.getItem("schemeCodeModel") === "18") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            //  setfarmerData(result.data.dataContent);
            //setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        } 
        
       
       
      else {
           let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";

        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict !== "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
          }

        
          if (sessionStorage.getItem("userTypeCodeModel") === "4") {
              subdistrictValueData = sessionStorage.getItem("subDistrictCodeModel") || 0;
          }
          
        if (selectedDataSetSubDistrict !== "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage !== "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
               "stateCode": stateValueData,
               "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,
                "PageNumber": page,
                "finYear": finYear
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);


             const data = await result.data.dataContent;
           
            console.log('data---------------',data);
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
            if (result.data.success != true) {
                  alert('No Data Found.');
                  setLoaderFarmer(false);
            }


        }



        // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);

    };

    let handleChange = (selectedStates) => {
        // Check if state selection is disabled for this user type
        if (isStateDisabled) {
            console.log("State change blocked - User has state restrictions");
            return;
        }
        
        console.log("selected State", selectedStates);
        setIsFetchingState(false);
        setStateValue(selectedStates.map(option => option.value));
        handleState(); // Call handleState after setting the state value
    };

    let handleChangeVillage = (villageValue) => {
        if (villageValue.length > 1) {
            alert('Please select one value');
            setvillageValue([]);
            return false;
        }
        else {

            setvillageValue(villageValue.map(option => option.value));
            setselectedDataSetVillage(villageValue.map(item => `${item.subDistrictCode}|${item.value}`).join(','));
        }
    };

    function formatData(value) {
        if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
            return value.componentName
        }
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Honey Processing Unit"
        } else if (value.orgTypeCode === 2) {
            return "Honey Testing Unit"
        } else if (value.orgTypeCode === 3) {
            return "Honey CHC"
        } else if (value.orgTypeCode === 4) {
            return "Beeflora Plantation"
        }
    }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
      setLoaderFarmer(true);
      
      let stateValueData = "";
      let districtValueData = "0";
      let subdistrictValueData = "0";
      let villageValueData = "0";

      // Concatenate all state values with a comma
      stateValue.forEach((item) => {
        stateValueData += item + ",";
      });
      // Remove trailing comma
      stateValueData = stateValueData.slice(0, -1);

      // If stateValueData is null or empty, set stateCode to "0"
      const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

      if (selectedDataSetDistrict !== "") {
        const districtParts = selectedDataSetDistrict.split("|");
        districtValueData = districtParts[1];
      }
      if (selectedDataSetSubDistrict !== "") {
        const SubdistrictParts = selectedDataSetSubDistrict.split("|");
        subdistrictValueData = SubdistrictParts[1];
      }
      if (selectedDataSetVillage !== "") {
        const VillageDataParts = selectedDataSetVillage.split("|");
        villageValueData = VillageDataParts[1];
      }
      console.log("stateValueData", stateCode);
      console.log("districtValueData", districtValueData);
      console.log("subdistrictValueData", subdistrictValueData);
      console.log("villageValueData", villageValueData);
      
      let result;
      if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
          {
           
            stateCode: stateCode, // Use our conditional stateCode here
            districtCode: districtValueData,
            subDistrictCode: subdistrictValueData,
            villageCode: villageValueData,
            PageNumber: 1,
          }
        );
        if (result.data.success === true) {
          const data = await result.data.dataContent;
          setIsFetching(false);
          setLoaderFarmer(false);
          return data;
        } else {
          alert("something went wrong.");
          setLoaderFarmer(false);
        }
      }
    };


    const handleExportDataNew = async () => {
        
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }
    const handleExportDataNewu = async () => {
    try {
        // Fetch data
        const farmerDataExportNew = await fetchDataExporttoCsv();
       //  console.log("aaaaaaaaaaaaaaaaaaaaaaa",farmerDataExportNew.data.dataContent)
        if(farmerDataExportNew.data.dataContent.length !=0){
        // Check if data is valid
        if (!farmerDataExportNew || !Array.isArray(farmerDataExportNew)) {
            console.error("Error: fetchDataExporttoCsv() returned invalid data", farmerDataExportNew);
            alert("Failed to export: No data available.");
            return;
        }

        // Allowed keys for export
       // const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName']
       

        // Transform data
        const result = farmerDataExportNew.map(obj => {
            let newObj = {};
            allowed.forEach(key => {
                newObj[key] = obj[key] ?? ""; // Ensure empty string for missing values
            });
            return newObj;
        });

        console.log("Export Data:", result);
        // Add export logic here
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
       } 
    } catch (error) {
        console.error("Error in handleExportDataNew:", error);
        alert("An error occurred while exporting data.");
    }
    };


    const handleExportData = () => {
        // alert(sessionStorage.getItem("schemeCodeModel") );
        let allowed;

        allowed = ['schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName','gisSchemeName','farmerName','mobileNo','surveyNo','componentName','finYear','surveyorName'];

        var result = farmerData?.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });


            return newObj;
        });

        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
    };


    function ValidateUpdateUser() {

        let valid = false;

        if (mobilenoValue === "") {
            alert("Enter Mobile no")

            valid = false;
            return;
        } else {
            valid = true;

        }
        if (landareaValue === "") {
            alert("Enter land area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (totalareaValue === "") {
            alert("Enter total area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (surveynoValue === "") {
            alert("Enter Survey No")

            valid = false;
            return;
        } else {
            valid = true;

        }


        if (valid === true) {
            UpdateNewUser()
        }

    }

    function UpdateNewUser() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "farmerCode": editCode,
            "mobileNo": mobilenoValue,
            "surveyNo": surveynoValue,
            "landArea": landareaValue,
            "totalArea": totalareaValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Nature/FarmerDetails/UpdateFarmerDetails`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
               // alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    // navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));

    }

    const handlePrevPage = async () => {
        setLoaderFarmer(true);
        let result;
        setPage(page - 1);
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1
            })
        }
       else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page - 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        setIsFetching(false);
        setHasNextPage(true)
    };

    const handleNextPage = async () => {
        setLoaderFarmer(true);
        setPage(page + 1);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {
                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page + 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        if (result.data.message === "Data Not Found") {
            setHasNextPage(false)
        }
        setIsFetching(false);
    };

    function handleSurveyNumber(value) {
        const valueFinal = value.replace(/\D/g, "");
        setSurveyValue(valueFinal)
    }

    function handleSurveyorName(value) {
        //alert(value);
       // const valueFinal = value.replace(/\D/g, "");
        setSurveyorNameValue(value)
        console.log("value==========",value)
        
    }

    const fetchDataFilterWises = async () => {
        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";
        
        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
      

        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {

            if (surveyValue != '') {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetails`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "CropSurveyCode": surveyValue
                });
            }
            else {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "schemeCode": "12",
                    "stateCode": stateValueData,
                    "districtCode": districtValueData,
                    "subDistrictCode": subdistrictValueData,
                    "villageCode": villageValueData,
                    "surveyorName": surveyorNameValue,
                    "cropSeasonValue": cropSeasonValue,
                    "cropGroupValue": cropGroupValue,
                    "cropNameValue": cropNameValue,
                    "fromdate": startDate,
                    "todate": endDate,
                    "PageNumber": 1
                });
            }


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "14") {

          
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEO_OP/getNMEOFarmerDetailsList`, {
                   
                    "schemeCode": "14",
                    "orgTypeCode": "1",
                    "lngA_FarmerCode": "0",
                    "int_Block_Code": "0",
                    "lng_SurveyUserCode": "0",
                    "str_MobileNo": "",
                    "int_State_Code": stateValueData,
                    "int_District_Code": districtValueData,
                    "int_SubDistrict_Code": subdistrictValueData,
                    "int_VillageCode": villageValueData,
         });
            


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "9") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           } 

        if (sessionStorage.getItem("schemeCodeModel") === "15") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/RKVY/RKVYProject/RKVYProjectExtList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": districtValueData,
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           }         

    };

    function ClearSearch(){
        // Only clear fields that are not disabled for this user type
        if (!isStateDisabled) {
            setStateValue([]);
            setOptionDistrict([]);
        }
        if (!isDistrictDisabled) {
            setDistrictValue([]);
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
        if (!isSubDistrictDisabled) {
            setsubDistrictValue([]);
            setselectedDataSetSubDistrict('');
        }
        
        // Always clear these fields regardless of user type
        setfarmerData([]);
        setOptionVillage([]);
        setvillageValue([]);
        setselectedDataSetVillage('');
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
    }

    function ValidateAddUser() {
    //alert(sessionStorage.getItem("schemeCodeModel"))
   // alert()
   
    if (stateValue.length === 0) {
       
         setErrorMessage("Please select at least one State.");
            return false;
    }
    if (stateValue.length > 1) {
       setErrorMessage("Please select only one State.");
            return false;
    }
    
    if (districtValue.length > 1) {
        setErrorMessage('Please select only one District');
        return false;
    }
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;
        
    }

    }
    // If all validations pass, fetch the filtered data
    setErrorMessage("") 
    fetchDataFilterWise();

    }


    function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }



    const columns = useMemo(() => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

        return [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1,
                size: 20,
            },
             // View Details Button Logic
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessor: '',
                header: 'View Details',
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/survey/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            } : (schemeCodeModel === "9") ? {
                accessor: '',
                header: 'Action',
                Cell: cell => (<>
                    <i className="btn" type="button" onClick={() => navigateData(cell.row.original)}> <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setEditCode(cell.row.original.farmerCode)}> <FontAwesomeIcon icon={faEdit} /></i>
                </>)
            } : {
                accessor: '',
                header: 'View Details',
                 size: 80,
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            },
       
           {
                accessorKey: 'stateName',
                header: 'State',
                size: 100,
            },
            {
                accessorKey: 'districtName',
                header: 'District',
                size: 100,
            }, {
                accessorKey: 'subDistrictName',
                header: 'subDistrictName',
                size: 100,
            },    {
                accessorKey: 'cropLifeCycleName',
                header: 'cropLifeCycleName',
                size: 100,
            }, {
                accessorKey: 'farmerName',
                header: 'farmerName',
                size: 100,
            },


            
           
                 ...(schemeCodeModel === "15" ? [
        { accessorKey: 'userName', header: 'User Name' },
        { accessorKey: 'sectorName', header: 'Sector Name' },
        { accessorKey: 'projectStatus', header: 'Project Status' }
    ] : []),

           
        ].filter(Boolean); // Use .filter(Boolean) to remove null entries
    }, []);


    return (
        <>
           <div className="row mb-4">
                        <div className="col-md-2 finacildd_label">
                            <div className="form-group text-white">
                                <label htmlFor="finYear" className="form-label text-white">Financial Year</label>
                                <select
                                    id="finYear"
                                    name="finYear"
                                    className="form-select"
                                    value={finYear}
                                    onChange={handleFinYearChange}
                                >
                                    <option value="2026-2027">2026-2027</option>
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2024-2025">2024-2025</option>
                                </select>
                            </div>
                        </div>
                    </div>
           <section className="section">

                <div className="row surveydetailsBg">
                    <div className="col-md-3">
                        <label htmlFor="State" className="form-label">
                            State
                        </label><label style={{ color: "red" }}>*</label>
                      <Select
                            options={optionState}
                            value={optionState.filter(option => stateValue.includes(option.value))[0] || null}
                            onChange={isStateDisabled ? () => {} : (opt) => handleChange(opt ? [opt] : [])}
                            isClearable={!isStateDisabled}
                            isSearchable
                            isDisabled={isStateDisabled}
                            placeholder="Select State"
                            classNamePrefix="select"
                        />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="District" className="form-label">
                            District
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionDistrict}
                            value={optionDistrict.filter(option => districtValue.includes(option.value))[0] || null}
                            onChange={isDistrictDisabled ? () => {} : (opt) => handleChangeDistrict(opt ? [opt] : [])}
                            isClearable={!isDistrictDisabled}
                            isSearchable
                            isDisabled={isDistrictDisabled}
                            placeholder="Select District"
                            classNamePrefix="select"
                        />
                    </div>

                   
                    <div className="col-md-3">
                        <label htmlFor="SubDistrict" className="form-label">
                            Sub District
                        </label><label style={{ color: "red" }}></label>



                        {isSubDistrictDisabled ? (
                            <Select
                                options={optionSubDistrict}
                                value={optionSubDistrict.filter(option =>
                                    subdistrictValue.includes(option.label)
                                )[0] || null}
                                isDisabled
                                placeholder="Select Sub District"
                                classNamePrefix="select"
                            />
                        ) : (
                            <Select
                                options={optionSubDistrict}
                                value={optionSubDistrict.filter(option =>
                                    subdistrictValue.includes(option.value)
                                )[0] || null}
                                onChange={(opt) => handleChangeSubDistrict(opt ? [opt] : [])}
                                isClearable
                                isSearchable
                                placeholder="Select Sub District"
                                classNamePrefix="select"
                            />
                        )}




                        {/*<MultiSelect*/}
                        {/*    options={optionSubDistrict}*/}
                        {/*    value={optionSubDistrict.filter(option => subdistrictValue.includes(option.label))}*/}
                        {/*    // value={selected}*/}
                        {/*    onChange={isSubDistrictDisabled ? () => {} : handleChangeSubDistrict}*/}
                        {/*    labelledBy={"Select"}*/}
                        {/*    isCreatable={true}*/}
                        {/*    disabled={isSubDistrictDisabled}*/}
                        {/*    defaultValue={subdistrictValue} />*/}

                    </div>
  
                    <div className="col-md-3">
                        <label htmlFor="Village" className="form-label">
                            Village
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionVillage}
                            value={optionVillage.filter(option => villageValue.includes(option.value))[0] || null}
                            onChange={(opt) => handleChangeVillage(opt ? [opt] : [])}
                            isClearable
                            isSearchable
                            placeholder="Select Village"
                            classNamePrefix="select"
                        />
                    </div>
                    
                  <br /> <br />                     
                  <div className="col-md-12 d-flex justify-content-md-center mt-3">
                    <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAddUser} >Submit</button>
                    <button type="button" className="btn btn-success me-md-2"  onClick={ClearSearch}>Clear</button>
                </div>

                </div>
                
                {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                         {errorMessage}
                        </div>
                    )} 

       
            {LoaderFarmer === false ? "" : <div className="overlay">
                <div className="overlay__inner">
                    <div className="overlay__content"><span className="spinner"></span></div>
                </div>
            </div>}


                    {(farmerData.length!==0  &&
                    <div className="row justify-content-lg-center">

                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={farmerData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sessionStorage.getItem("schemeCodeModel") === "12" ?
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportDataNew}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>

                                                :
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                            }

                                        </Box>
                                    )}
                                />
                                

                            </div>

                        </div>


                    </div>
                )}
           </section>

        

         
          
        </>
    )
}

export default MIDHList;